import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import React from "react";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { ArticleCardSerializer } from "web/types/serializers";
import * as styles from "./tertiary-article-card.css";

interface TertiaryArticleCardProps
    extends Pick<
        ArticleCardSerializer,
        "title" | "thumbnails" | "is_sponsored" | "article_url" | "position"
    > {
    onClick: (area: string) => void;
    variant?: "sm" | "lg";
    hasBackground?: boolean;
}

export function TertiaryArticleCard({
    title,
    thumbnails,
    is_sponsored: isSponsored,
    article_url: articleUrl,
    position,
    variant = "sm",
    hasBackground = true,
    onClick,
}: TertiaryArticleCardProps): React.ReactElement {
    return (
        <div data-testid={`editorial-content-card-tertiary-${position}`}>
            <a href={articleUrl} target={"_blank"} rel="noopener noreferrer">
                <View
                    className={clsx(styles.articleCardContent, {
                        [styles.articleCardBorder]: hasBackground,
                        [styles.articleCardContentContainer[variant]]: variant,
                    })}
                >
                    <View
                        className={clsx(styles.imageContainer, {
                            [styles.imageContainerVariant[variant]]: variant,
                        })}
                        onClick={() => onClick("image")}
                        dataTestId="tertiary-article-image"
                    >
                        <img
                            className={clsx(styles.image, {
                                [styles.thumbnailMask]: isSponsored,
                            })}
                            src={thumbnails?.landscape.sm}
                            alt={title}
                        />
                        {isSponsored && (
                            <>
                                <View
                                    style={assignInlineVars({
                                        [styles.overlayBackgroundHeight]: "48%",
                                    })}
                                    className={styles.thumbnailTextOverlayBackground}
                                />
                                <View
                                    padding="xxs"
                                    className={styles.thumbnailTextOverlayContainer}
                                >
                                    <Text textStyle="caption-3" color="information" upperCase>
                                        {gettext("general.sponsored_label")}
                                    </Text>
                                </View>
                            </>
                        )}
                    </View>
                    <View
                        className={styles.textContainer}
                        marginY="xxs"
                        onClick={() => onClick("cta")}
                        dataTestId="tertiary-article-cta"
                    >
                        <View marginBottom="xxs">
                            <Text textStyle="body-s" color="primary" wordBreak lineLimit={2}>
                                {title}
                            </Text>
                        </View>
                        <Text textStyle="body-s-bold" color="primary" underline>
                            {gettext("general.read_and_shop")}
                        </Text>
                    </View>
                </View>
            </a>
        </div>
    );
}
